import React from 'react';

import { Chip } from '@swyftx/aviary/atoms/Chip';

import { capitalize } from '@utils/formatting';

import { observer } from 'mobx-react-lite';
import { useMarginPositionDetails } from 'src/lib/margin/hooks/positions';

type Props = {
  positionId?: string;
};

const MarginPositionsTableStatus: React.FC<Props> = observer(({ positionId }) => {
  const { position } = useMarginPositionDetails({ positionId });

  if (!position) return null;

  return (
    <Chip variant='subtle' color='info' size='md'>
      {capitalize(position.status)}
    </Chip>
  );
});

export { MarginPositionsTableStatus };
